import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Standard } from 'components/Page';
import config from './config';

const Cycles = ({ permissions }) => (
  <Standard
    canAdmin={permissions.CanAdminAvailabilities()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.availabilityCycle,
      list: REDUCER_KEY.availabilityCycles
    }}
    config={config}
    permissions={permissions}
  />
);

Cycles.propTypes = {
  permissions: PropTypes.object.isRequired
};

export default Cycles;
